import React, { Suspense, lazy } from "react";
import "./Container.css";
import LandingPage from "./LandingPage/LandingPage";
import Header from "./Header/Header";

const AboutAmalgamatePage = lazy(() => import("./AboutAlgamatePage/AboutAmalgamatePage"));
const AmalgamateWorks = lazy(() => import("./AmalgamateWorksPage/AmalgamateWorksPage"));
const DonationComponent = lazy(() => import("./DonationComponent/DonationComponent"));
const FAQPage = lazy(() => import("./FAQPage/FAQPage"));
const DownloadAppPage = lazy(() => import("./DownloadAppPage/DownloadAppPage"));

function Container() {
  return (
    <div className="Container">
      <Header />
      <LandingPage />
      <Suspense fallback={null}>
        <AboutAmalgamatePage />
        <AmalgamateWorks />
        <DonationComponent />
        <FAQPage />
        <DownloadAppPage />
      </Suspense>
    </div>
  );
}

export default Container;
